export var constants = {
    Copyright_text1: 'Copyright © Deloitte Development LLC ',
    Copyright_text2: '. All Rights Reserved.',
    Copyright_text3: 'Deloitte',
    Login_button: 'Explore now',
    exit_msg: 'Are you sure you want to exit',
    cancel: 'Cancel',
    logout: 'Logout',
    close: 'Close',
    privacy: 'Privacy',
    cookies: 'Cookies',
    terms_of_use: 'Terms of Use',
    appstore_login_title: 'Welcome to App Store',
    appstore_login_description: 'Your portal to a comprehensive suite of' + ' applications, ready for project deployment.',
    appstore_login_button: 'Explore now',
    // -----------------------------Constants for Product Selection page----------------------------------
    welcome_title: 'Welcome To',
    welcome_content: 'Please select which tool you would like today.',
    selectTool_Line: 'Please select which tool you would like today.',
    title_forecasting: 'Forecasting',
    content_forecasting: 'The irrefutable leader in predicting' + ' consumer demand at scale in an accurate, actionable, and explainable way.',
    button_demand_brain: 'Go to Forecasting',
    title_featureFactory: 'Feature Foundry',
    policy_name_featureFactory: 'FeatureFactory',
    content_featureFactory: 'A suite of functions that take in data,' + ' derive features relevant for a particular use case,' + ' cleanse and prepare data for madeling, and store' + ' feature specs for reproduction and serving.',
    button_featureFactory: 'Go to Feature Foundry',
    title_conductor: 'Conductor',
    content_conductor: 'Generates cross-decision opportunities,' + ' routes opportunities to the right decision maker,' + ' and connects into planning systems for execution,' + ' tracking, learning.',
    button_conductor: 'Go to Conductor',
    button_associate_productivity: 'Go to Associate Productivity',
    button_self_service: 'Go to Self Service',
    button_segmentation: 'Go to Segmentation',
    button_idr: 'Go to IDR',
    button_insights_engine: 'Go to Insights Engine',
    title_associate_productivity: 'AssociateProductivity',
    title_self_service: 'SelfService',
    title_segmentation: 'Segmentation',
    title_idr: 'IDR',
    title_insights_engine: 'InsightsEngine',
    heading1ConvergeTitle: 'Converge',
    heading2ConvergeTitle: 'Consumer',
    your_apps: 'Your Apps',
    open: 'Open',
    //------------------------------------End of Constants for Product Selection page--------------------
    //End of Constants for Product Selection page
    // --------------------- 404 Page ---------------------------------
    title_404: 'Error 404: Page not Found',
    desc_404: 'Webpage does not exist.',
    return_to_home: 'Return to home',
    page_crashed: 'OOPS! Application crashed...',
    no_app: 'User not assigned to any application',
    wrong_app: 'User does not have access to the application',
    // --------------------- End of 404 Page -------------------------
    // --------------------- Settings ---------------------------------
    apply: 'Apply'
};
